import { render, staticRenderFns } from "./gl-reporting-group.vue?vue&type=template&id=7c3644f0"
import script from "./gl-reporting-group.vue?vue&type=script&lang=js"
export * from "./gl-reporting-group.vue?vue&type=script&lang=js"
import style0 from "./gl-reporting-group.vue?vue&type=style&index=0&id=7c3644f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports